<template>
  <div class="inspection--address">
    <h3>Inspection</h3>

    <p class="folder-address1">{{receipt.folder.address1}}</p>
    <p class="folder-address2">{{receipt.folder.address2}}</p>
    <p class="folder-city">
      <span v-if="!receipt.folder.city">
        {{receipt.folder.state}} {{receipt.folder.postalCode}}
      </span>
      <span v-else>
        {{receipt.folder.city}}, {{receipt.folder.state}} {{receipt.folder.postalCode}}
      </span>
    </p>
    <p v-if="receipt.reportid" class="invoices-id">
      ID: {{receipt.reportid}}
    </p>

    <template v-if="showBillTo">
      <h3 class="bill-to-header">Bill to</h3>
      <p class="folder-name">
        {{receipt.givenName}} {{receipt.familyName}}
      </p>
      <p class="folder-email">
        {{receipt.email}}
      </p>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    receipt: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showBillTo() {
      return !!(this.receipt.givenName
          || this.receipt.familyName
          || this.receipt.email);
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
  font-size: 1.5rem;
  text-transform: uppercase;
}

p {
  font-size: 1.15rem;
  line-height: 1.6;
  margin: 0;
}

.bill-to-header {
  margin-top: 30px;
}

@media all and (max-width: 600px) {
  .inspection--address {
    padding-top: 30px;
  }
}
</style>
